module.exports = __webpack_public_path__ + "static/media/cd.732f19e7.svg";